import { FC, useState } from "react";
import { toast } from "react-toastify";
import { Spacer } from "../../../../components";
import { RowDiv } from "../../../../components/misc/misc.styled";
import { useParams } from "react-router-dom";
import { Customer, Payment, Project, PayType } from "../../../../redux/types";
import { ProjectDetailsQueryData } from "../../../../redux/types/projectDetails";
import { useEditPaymentMode } from "../../../../apolloClient/hooks/itemCreation/createHooks"; // Import useEditPaymentMode
import { PaymentMethodUpdateInput } from "../../../../types/graphQlQuery.interface"; // Import PaymentMethodUpdateInput

interface PaymentModeProps {
  handleRefetchProducts: Function;
  paymentModedata?: Project;
}

export const PaymentMode: FC<PaymentModeProps> = ({
  handleRefetchProducts,
  paymentModedata,
}) => {
  const { id } = useParams();
  const [selectedPaymentMode, setSelectedPaymentMode] = useState<PayType | undefined>(
    paymentModedata?.paymentType
  );
  const { editPaymentMode } = useEditPaymentMode(); // Use editPaymentMode hook

console.log("paymentModedata:", paymentModedata?.paymentType);

  const handleSavePaymentModeChanges = async () => {
    try {
      if (!selectedPaymentMode) {
        toast.error("Please select a payment mode before saving.");
        return;
      }

      const input: PaymentMethodUpdateInput = {
        paymentType: selectedPaymentMode,
        projectId: Number(id),
      };

      const success = await editPaymentMode(input);
      
      if (!success) {
        toast.error("Failed to save changes. Please try again.");
        return;
      }
      
      handleRefetchProducts();
      toast.success("Payment mode saved successfully!");
    } catch (error) {
      console.error("Error saving payment mode:", error);
      toast.error("An error occurred while saving changes. Please try again.");
    }
  };

  return (
    <>
      <div
        style={{
          padding: "16px",
          backgroundColor: "#f8fafc",
          minHeight: "100%",
        }}
      >
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ textAlign: "center", marginBottom: "16px", fontSize: "20px", fontWeight: 600, color: "#1f2937" }}>
            Select Payment Mode
          </h2>
          <p
            style={{
              textAlign: "center",
              marginBottom: "20px",
              color: "#6b7280",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            Tell us how you plan to pay. We help you facilitate your payment
            options at a later stage during your project.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "16px",
              maxHeight: "500px",
              overflowY: "auto",
              padding: "16px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              backgroundColor: "#ffffff",
            }}
          >
            {[
              {
                id: PayType.INSURANCE,
                label: "Insurance proceeds",
                icon: "🏠",
              },
              { id: PayType.CASH, label: "Cash payment", icon: "💵" },
            ].map((option) => (
              <div
                key={option.id}
                onClick={() => setSelectedPaymentMode(option.id)}
                style={{
                  border:
                    selectedPaymentMode === option.id
                      ? "2px solid #007BFF"
                      : "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "10px",
                  width: "200px",
                  textAlign: "center",
                  backgroundColor:
                    selectedPaymentMode === option.id ? "#E6F0FF" : "#fff",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                <div style={{ fontSize: "40px", marginBottom: "10px" }}>
                  {option.icon}
                </div>
                <h4
                  style={{
                    margin: "10px 0",
                    fontSize: "16px",
                    color: "#333",
                  }}
                >
                  {option.label}
                </h4>
              </div>
            ))}
          </div>
          <button
            onClick={handleSavePaymentModeChanges}
            style={{
              marginTop: "20px",
              padding: "12px 24px",
              backgroundColor: "#4b87ed",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              float: "right",
              fontSize: "14px",
              fontWeight: 500,
              transition: "background-color 0.2s",
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};
